import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Train(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M18 9a1 1 0 01-1 1h-4V4h4a1 1 0 011 1v4zm-1.5 6a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0116.5 15zM7 22l1-2h8l1 2H7zm-1-8.5a1.5 1.5 0 113.001.001A1.5 1.5 0 016 13.5zM6 5a1 1 0 011-1h4v6H7a1 1 0 01-1-1V5zM17.217.913C15.747.444 13.864 0 12 0c-1.878 0-3.757.441-5.221.909A3.997 3.997 0 004 4.72v10.56a3.99 3.99 0 002.51 3.701L4 24h16l-2.51-5.019A3.99 3.99 0 0020 15.28V4.725A3.998 3.998 0 0017.217.913z"
  }));
}

export { Train };
//# sourceMappingURL=Train.js.map